module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b4yx9"))).then(() => parcelRequire('f4eak'));